import { useLayoutEffect, useMemo, useRef } from "react";
import { message } from "antd";
import { marked } from "marked";
import { fmtDateTimeFull } from "@extensions/utils";
import "./cyber.css";

/** Сообщение пользователя: Incoming = 1 (как в message-dialogs). Ответ бота/оператора: Outcoming = -1. */
const isFromUser = (direction) => Number(direction) === 1;

const COPY_ICON_SVG =
  '<svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"></path></svg>';

const enhanceCodeBlocks = (root) => {
  if (!root) return;
  root.querySelectorAll("pre").forEach((pre) => {
    if (pre.parentElement?.classList.contains("cyber-code-block")) return;

    const wrap = document.createElement("div");
    wrap.className = "cyber-code-block";
    pre.parentNode.insertBefore(wrap, pre);
    wrap.appendChild(pre);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cyber-code-copy";
    btn.title = "Копировать";
    btn.setAttribute("aria-label", "Копировать");
    btn.innerHTML = COPY_ICON_SVG;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const text = pre.innerText ?? "";
      if (!text) return;
      navigator.clipboard.writeText(text).then(
        () => message.success("Скопировано в буфер обмена"),
        () => message.error("Не удалось скопировать")
      );
    });
    wrap.appendChild(btn);
  });
};

const CyberMessage = ({ message }) => {
  const outgoing = isFromUser(message.direction);
  const contentRef = useRef(null);
  const html = useMemo(
    () => (outgoing ? "" : marked.parse(message.body || "")),
    [outgoing, message.body]
  );

  useLayoutEffect(() => {
    if (outgoing) return;
    enhanceCodeBlocks(contentRef.current);
  }, [outgoing, html]);

  const metaParts = [];
  if (message.createdOn) metaParts.push(fmtDateTimeFull(message.createdOn));
  if (message.operator) metaParts.push(message.operator);

  return (
    <div className={`cyber-message ${outgoing ? "cyber-message-outgoing" : "cyber-message-incoming"}`}>
      {metaParts.length > 0 && (
        <div className="cyber-message-meta">
          {metaParts.join(" · ")}
        </div>
      )}
      {outgoing ? (
        <div className="cyber-message-block cyber-message-ask">
          {message.body}
        </div>
      ) : (
        <div
          ref={contentRef}
          className="cyber-message-block cyber-message-answer cyber-markdown"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  );
};

export default CyberMessage;
